<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">商品选择</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body" style="padding:20px">
                <el-row>
                    <el-col :span="24">
                        <el-table
                            :data="goodsInfo"
                            style="width: 100%" border height="550">
                            <el-table-column prop="name" fixed label="标题" width="200"></el-table-column>
                            <el-table-column prop="nameMore" label="副标题" width="200"></el-table-column>
                            <el-table-column prop="price" label="市场价"></el-table-column>
                            <el-table-column prop="priceSale" label="销售价"></el-table-column>
                            <el-table-column prop="stock" label="库存"></el-table-column>
                            <el-table-column prop="goodsClassName" label="商品分类"></el-table-column>
                            <el-table-column fixed="right" label="操作" width="200">
                                <template slot-scope="scope">
                                    <el-button type="primary" size="small" @click="handleAddOrder(scope.$index, scope.row)">下单</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-col>
                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;margin-top:10px">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;margin-top:10px">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    :current-page.sync="currentPage"  @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>
                </el-row>

            </div>
        </div>
        <AddOrder ref="myAddOrder" v-show="showModalAddOrder" v-on:closeAddOrder="closeAddOrder"></AddOrder>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import AddOrder from "./AddOrder"

    export default {
        name: 'GetGood',
        data() {
            return {
                showModalAddOrder:false,
                loading: false,
                goodsInfo:[],
                elderly:'',
                totalItems:0,
                pageSize:20,
                pageIndex:1,
                elderlyCode:'',
            }
        },
        components:{
            AddOrder
        },
        methods: {
            init(row){

                this.elderlyCode=row.elderlyCode
                // this.businessCode=row.businessCode
                this.getGoods()
            },
            closeSelf() {
                this.$emit("closeGetGood");
            },
            current_change:function(currentPage){
                this.pageIndex = currentPage;
                this.getGoods();
            },
            handleAddOrder(index, row) {
                this.$refs.myAddOrder.init(row,this.elderlyCode);
                this.showModalAddOrder = !this.showModalAddOrder;
            },
            closeAddOrder:function(){
                this.showModalAddOrder = !this.showModalAddOrder;
            },
            getGoods(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Goods/GetPageByBusinessCodeServe",
                    data: {
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        timeStr:timeStr,
                        staffCode:getStaffCode(),
                        pageSize:20,
                        pageIndex:this.pageIndex,
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.goodsInfo=response.data.data.list;
                            this.totalItems = response.data.data.total;
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },
        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 1000px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height:600px;
            }
            .modal-body /deep/ .el-card.is-always-shadow{
                box-shadow:none;
                border-bottom: none;
                margin-bottom: 20px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
